// extracted by mini-css-extract-plugin
module.exports = {"wrap":"TitleAndTextBlock_wrap__bvRaI","title":"TitleAndTextBlock_title__aUyPF","text":"TitleAndTextBlock_text__O5Y8_"};